import { useMemo } from 'react';
import { useEventContext } from '../contexts/EventContext';
import { STAT_KEYS, StatKey } from '../types/dto';

export const useEventStatsConfig = () => {
  const { currentEvent } = useEventContext();

  return useMemo(() => {
    const stored = currentEvent?.config?.enabledStats;
    const enabled: Set<StatKey> =
      stored && stored.length > 0
        ? new Set(stored)
        : new Set<StatKey>(STAT_KEYS);
    return {
      enabled,
      isStatEnabled: (k: StatKey) => enabled.has(k),
      anyPointsEnabled:
        enabled.has('onePoints') ||
        enabled.has('twoPoints') ||
        enabled.has('threePoints'),
    };
  }, [currentEvent?.config?.enabledStats]);
};
